export default __webpack_public_path__ + "static/media/rs-arte-11.bcb31dd7.webp";